import { readonly } from "vue";
import { storeToRefs } from "pinia";

import { useAuthStore } from "@/stores/authStore";

const useAuth = () => {
  const authStore = useAuthStore();
  const { isAuthenticated, user } = storeToRefs(authStore);

  // ACTIONS
  const login = async (email, password) => {
    try {
      const response = await authStore.login(email, password);

      authStore.setAuthData(response.data, null);

      await getUserData();

      return response;
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  };

  const logout = () => {
    authStore.clearAuthData();
    location.reload();
  };

  const forgotPassword = async (email) => {
    try {
      const response = await authStore.forgotPassword(email);
      return response;
    } catch (error) {
      console.error("Forgot password error:", error);
      throw error;
    }
  };

  const setPassword = async (token, password, password_confirmation) => {
    try {
      const response = await authStore.setPassword(token, password, password_confirmation);
      return response;
    } catch (error) {
      console.error("Reset password error:", error);
      throw error;
    }
  };

  const acceptInvitation = async (token, password, password_confirmation) => {
    try {
      const response = await authStore.acceptInvitation(token, password, password_confirmation);
      return response;
    } catch (error) {
      console.error("Accept invitation error:", error);
      throw error;
    }
  };

  const getInvitationDetail = async (token) => {
    try {
      const response = await authStore.getInvitationDetail(token);
      return response.data;
    } catch (error) {
      console.error("Invitation detail error:", error);
      throw error;
    }
  };

  const getUserData = async () => {
    try {
      const response = await authStore.userData();
      const user = response.data;

      authStore.setAuthData(
        {
          token: authStore.token,
          expires_at: authStore.expiresAt,
        },
        user
      );

      return user;
    } catch (error) {
      console.error("Get user data error:", error);
      throw error;
    }
  };

  return {
    // DATA
    isAuthenticated: readonly(isAuthenticated),
    user: readonly(user),
    // ACTIONS
    login,
    logout,
    forgotPassword,
    acceptInvitation,
    getInvitationDetail,
    setPassword,
    getUserData,
  };
};

export default useAuth;
